import React, { useState } from "react";
import Modal from "../modal-new";
import submit from "submit-form";

const FilterNewsModal = ({ filterFrom, filterTo, filterPublished }) => {
  const [from, setFrom] = useState(filterFrom || "");
  const [to, setTo] = useState(filterTo || "");
  const [publishedFilter, setPublishedFilter] = useState(
    filterPublished === "1" ? "published" : filterPublished === "0" ? "unpublished" : null
  );

  const handleSave = () => {
    submit("/actions/refresh/?", {
      method: "GET",
      body: {
        filterFrom: from || "",
        filterTo: to || "",
        filterPublished: publishedFilter === "published" ? "1" : publishedFilter === "unpublished" ? "0" : "",
        modal: "",
      },
    });
  };

  const handleClear = () => {
    setFrom("");
    setTo("");
    setPublishedFilter(null);
  };

  const handleToggle = (value) => {
    setPublishedFilter((prev) => (prev === value ? null : value));
  };

  return (
    <Modal title="Filter News">
      <div className="body">
        <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
          <div>
            <p style={{ marginBottom: "0.5rem", fontWeight: "600" }}>Date Range</p>
            <div style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}>
              <input
                type="date"
                value={from}
                onChange={(e) => setFrom(e.target.value)}
                className="text-input"
              />
              <span>to</span>
              <input
                type="date"
                value={to}
                onChange={(e) => setTo(e.target.value)}
                className="text-input"
              />
            </div>
          </div>
          <div>
            <p style={{ marginBottom: "0.5rem", fontWeight: "600" }}>Status</p>
            <div style={{ display: "flex", gap: "1.5rem" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                <input
                  type="checkbox"
                  role="switch"
                  id="filter-news-published"
                  checked={publishedFilter === "published"}
                  onChange={() => handleToggle("published")}
                />
                <label htmlFor="filter-news-published">Published</label>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                <input
                  type="checkbox"
                  role="switch"
                  id="filter-news-unpublished"
                  checked={publishedFilter === "unpublished"}
                  onChange={() => handleToggle("unpublished")}
                />
                <label htmlFor="filter-news-unpublished">Unpublished</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer>
        <button data-button-type="secondary" onClick={handleClear}>
          Clear all
        </button>
        <button data-button-type="primary" onClick={handleSave}>
          Apply
        </button>
      </footer>
    </Modal>
  );
};

export default FilterNewsModal;
